import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
    App,
    AlertController,
    LoadingController,
    Events,
    NavParams,
    Slides,
    ModalController,
    NavController, Platform
} from 'ionic-angular';
import { RechargePage } from '../recharge/recharge';
import { LotteryTabsPage } from "../lotteryTabPanel/lotteryTabPanel";
import { WithDrawalPage } from "../withDrawal/withDrawal";
import { UserService } from "../../services/user.services";
import { AppConfigService } from "../../services/appConfig.service";
import { LotteryService } from "../../services/lottery.services";
import { SysMsgViewPage } from "../personMsgView/sysMsgView";
import { ServicePage } from "../service/service";
import { LotteryPage } from "../lottery/lottery";
import { AppConfig } from "../../util/appConfig";
import { Observable } from 'rxjs';

import { UserTest } from "../userTest/userTest";
import { AppDialog } from "../../component/appDialog";

import { CommonService } from "../../services/common.service";
import { FeedbackPage } from "../feedback/feedback";
import { FundTransferPage } from "../fundTransfer/fundTransfer";
import { PromoMsgPage } from "../promoMsg/promoMsg";
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import * as common from "../../directives/common";
import { BauCua1GiayPage } from "../baucua1giay/baucua1giaypage";
import { OanTuTiPage } from "../oantuti/oantutipage";
import { BauCua1PhutPage } from "../baucua1phut/baucua1phutpage";
import { LoginPage } from "../login/login";
import { SpeedTestPage } from "../speedTest/speedTest";
import { ToastController } from "ionic-angular";
import { UserPage } from '../user/user';
import { TabsPage } from '../tabs/tabs';
import { TranslateService } from 'ng2-translate';


@Component({
    templateUrl: 'home.html',
    selector: 'home-page',
})

export class HomePage implements OnInit {
    appName: string;
    //昵称
    static nickname: string;
    public vnd: string = 'VNDK';
    logoUrl = '/build/assets/images/logoHeader.png';
    avatarUrl = 'build/assets/images/home/avatar-2.webp';
    //登录名字
    static loginname: string;
    static lotteryIDList: any = {};
    tabGames = ['0', '1', '2', '3', '4', '5', '6', '7']
    //private mySlnameeRes:
    private lotteryList = AppConfig.LotteryList(this.translate);

    msgList: any = [];
    normalNotiList: any = [];
    popupNotiList: any = [];
    bannerList: any = [];

    menuItemHome: any = [];
    currentMenu: any = [];
    configVipItems: any = [];

    public isAccountTest: boolean = true;
    public contentNoti: string = '';
    static zaloID: string = '';

    selectOptions = [
        { value: '-1', label: this.translate.instant('TẤT_CẢ') },
        { value: '1', label: this.translate.instant('THỨ_2') },
        { value: '2', label: this.translate.instant('THỨ_3') },
        { value: '3', label: this.translate.instant('THỨ_4') },
        { value: '4', label: this.translate.instant('THỨ_5') },
        { value: '5', label: this.translate.instant('THỨ_6') },
        { value: '6', label: this.translate.instant('THỨ_7') },
        { value: '0', label: this.translate.instant('CHỦ_NHẬT') }
    ];

    selectedMT: string;
    selectedMN: string;
    userData: any;

    @ViewChild('loopSlider') loopSlider: Slides;
    @ViewChild('loopSliderBanner') loopSliderBanner: Slides;
    sliderObservableNoti: any;
    sliderObservableBanner: any;

    public arrObjPromo: any = [];

    @ViewChild('giftElement') giftElement: ElementRef;
    private elMove: any;
    private offsetX;
    private offsetY;
    private wApp;
    private hApp;
    private hBox;
    private wBox;

    private balance: string = '0';
    public selectedLanguage = 'vi';
    isLoadingBalance: boolean = false;
    tabSelect: string = 'xoso';
    options: InAppBrowserOptions = {
        location: 'yes',//Or 'no'
        hidden: 'no', //Or  'yes'
        clearcache: 'yes',
        clearsessioncache: 'yes',
        zoom: 'yes',//Android only ,shows browser zoom controls
        hardwareback: 'yes',
        mediaPlaybackRequiresUserAction: 'no',
        shouldPauseOnSuspend: 'no', //Android only
        closebuttoncaption: 'Close', //iOS only
        disallowoverscroll: 'no', //iOS only
        toolbar: 'yes', //iOS only
        enableViewportScale: 'no', //iOS only
        allowInlineMediaPlayback: 'no',//iOS only
        presentationstyle: 'pagesheet',//iOS only
        fullscreen: 'yes',//Windows only
    };
    constructor(private app: App, private nav: NavController, public params: NavParams, public events: Events, public loadingCtrl: LoadingController, public alertCtrl: AlertController, private platform: Platform,
        private userService: UserService, private lotteryService: LotteryService, private commonSV: CommonService, public modalCtrl: ModalController, public cs: CommonService, private el: ElementRef, public navCtrl: NavController,
        private theInAppBrowser: InAppBrowser, private toastCtrl: ToastController,
        private cdr: ChangeDetectorRef, private translate: TranslateService
    ) {

        const storedLanguage = localStorage.getItem('langcode');
        if (storedLanguage) {
            this.selectedLanguage = storedLanguage;
        } else {
            this.selectedLanguage = 'vi'; // Mặc định là tiếng Anh nếu không có giá trị trong localStorage
        }

        if (this.cs.userType > 1) {
            this.isAccountTest = false;
        }
        this.appName = AppConfig.appName;
        HomePage.loginname = params.data["loginname"];
        this.userData = params.data;
        cs.flagVerifyNumber = this.params.data["verifiedphone"];
        // god game auto
        // console.log('LoginPage?.paramGameInfo', LoginPage?.paramGameInfo);

        if (LoginPage?.paramGameInfo !== '') {
            let parram_codegame = this.selectedLanguage == 'vi' ? 'gamedesc' : 'gamedesc'+this.selectedLanguage;
            this.goLottery(LoginPage.paramGameInfo.gamecodepc, LoginPage.paramGameInfo[parram_codegame], LoginPage.paramGameInfo.gameid, LoginPage.paramGameInfo.name)
        }
        
        platform.ready().then((readySource) => {
            this.wApp = platform.width();
            this.hApp = platform.height();
        });

        if (window['requestIdleCallback']) {
            window['requestIdleCallback'](() => {
                window['Fingerprint2'].get(components => {
                    this.getParamsAuditUser(components) // an array of components: {key: ..., value: ...}
                });
            });
        } else {
            setTimeout(() => {
                window['Fingerprint2'].get(components => {
                    this.getParamsAuditUser(components) // an array of components: {key: ..., value: ...}
                });
            }, 500)
        }

        
        this.apiGetBalance();
        events.subscribe('getbalance:get', (dataEvent) => {
            this.apiGetBalance();
        });

    }


    handleChangeTab(tabValue: any) {
        this.tabSelect = tabValue;
        this.filterTabMatch(tabValue);
    }

    filterTabMatch(tabSelect: string) {
        // console.log("ook", this.tabSelect);

        // filter lottery list
        if (this.tabSelect === '' || this.tabSelect === 'home') {
            this.currentMenu = this.menuItemHome;
        } else {
            this.currentMenu = this.menuItemHome.filter((item) => item.type === tabSelect);
        }

    }








    apiGetBalance() {
        this.isLoadingBalance = true;
        this.lotteryService.getBalance(data => {
            this.balance = this.commonSV.numberWithCommas(data["balance"]);;
            this.isLoadingBalance = false;
        });
    }

    getParamsAuditUser(components) {
        const paramsAudit = { fingerprint: window['Fingerprint2'].x64hash128(components.map(function (pair) { return pair.value }).join(), 31) };
        components.forEach(item => {
            if (item['key'] === 'userAgent') paramsAudit['userAgent'] = item['value'];
            else if (item['key'] === 'screenResolution') paramsAudit['screenResolution'] = item['value'].join(',');
            else if (item['key'] === 'timezone') paramsAudit['timezone'] = item['value'];
            else if (item['key'] === 'platform') paramsAudit['platform'] = item['value'];
        });
        this.userService.auditUser(paramsAudit, null).then(data => {
            console.log(data);
        });
    }

    ngOnInit() {
        this.initData();
        this.setCurrentDay();


    }

    setCurrentDay() {
        const today = new Date();
        const day = today.getDay(); // 0 for Sunday, 1 for Monday, etc.
        this.selectedMT = day.toString();
        this.selectedMN = day.toString(); // Set the selected value based on the current day
    }




    initData() {

        this.userService.initHome(undefined, this.alertCtrl).then(data => {

            if (data["msg"] == "") {
                HomePage.zaloID = data["zaloID"];
                this.bannerList = data["bannerlist"];
                this.msgList = data["msglist"];
                this.logoUrl = data["logoUrl"];
                this.avatarUrl = data["avatarUrl"];
                LoginPage.paramUserLogin['avatarUrl'] = this.avatarUrl
                // if (LoginPage.cytype == 0) {
                //     this.vnd = 'VNDK'
                // } else {
                //     this.vnd = 'VND'
                // }
                this.vnd = LoginPage.cyName

                UserPage.helpUrl = data["helpUrl"]
                this.normalNotiList = this.msgList.filter(item => item.param1 === 1 && item.status === 1);
                this.menuItemHome = data["menuItemHome"];
                this.menuItemHome = data["menuItemHome"].filter(item => item.type !== 'home');


                // let userName = this.base64Util.decode(urlParams.get('?username'));

                // panto: go tab
                let queryString = window.location.search;
                if (queryString !== "") {
                    let urlParams = new URLSearchParams(queryString);
                    let gameId = urlParams.get('gameId');
                    if (this.tabGames.indexOf(gameId) !== -1) {
                        console.log('gameId', gameId);
                        console.log('gameId', this.menuItemHome[Number(gameId)]);
                        this.tabSelect = (this.menuItemHome[Number(gameId)] != undefined) ? this.menuItemHome[Number(gameId)].type : this.tabSelect
                    }
                }
                this.handleChangeTab(this.tabSelect);
                setTimeout(() => {
                    this.showPopupNoti();
                }, 400);
            }
            this.configVipItems = data['configVipItems'][0];
            localStorage.setItem('configVipItems', JSON.stringify(data['configVipItems'][0]));
            // console.log('this.configVipItems',this.configVipItems);
            this.cdr.detectChanges();
        });


    }

    goSysMsg(mgId: string) {
        this.app.getRootNav().push(SysMsgViewPage, {
            id: mgId
        });
    }


    goUser1() {
        // this.paramUser = LoginPage.paramUserLogin;
        // this.paramUser = LoginPage.paramUserLogin;
        // console.log('====================================');
        // console.log('LoginPage.paramUserLogin',LoginPage.paramUserLogin);
        // console.log('====================================');
        this.nav.push(UserPage, {
            paramUser: LoginPage.paramUserLogin
            // paramUser: this.userData
        });
    }

    goUser2(index: number) {
        // this.navCtrl.push(TabsPage, { tabIndex: index });
        this.app.getRootNav().setRoot(TabsPage, { tabIndex: index });
        // this.navCtrl.setRoot(TabsPage, { tabIndex: index });
    }

    contact() {
        let alertCmp = this.alertCtrl.create({
            title: "Hỗ Trợ 24/7",
            cssClass: 'alertSupport247',
            message:
                '<div class="support247">' +
                '<div title="hotro"><img src="build/assets/images/home/supportOnline.png" />Hỗ Trợ 24/7</div>' +
                '<div title="telegram"><img src="build/assets/images/home/telegramicon.png" />Telegram</div>' +
                '</div>',
            buttons: [{ text: 'Đóng' }]
        });
        alertCmp.present().then(() => {
            const elSupport: any = document.querySelectorAll('.support247 > div');
            for (let i = 0; i < elSupport.length; i++) {
                elSupport[i].addEventListener('click', (e) => {
                    let getFlag = elSupport[i].getAttribute('title');
                    alertCmp.dismiss();
                    if (getFlag === 'hotro') {
                        this.app.getRootNav().push(ServicePage);
                    } else if (getFlag === 'telegram') {
                        this.theInAppBrowser.create('https://t.me/CVDAILILODEVN99', "_system", this.options);
                    }
                    /* else if (getFlag === 'zalo') {
                        if (HomePage.zaloID !== '') {
                            this.theInAppBrowser.create('https://zalo.me/' + HomePage.zaloID, "_system", this.options);
                        } else {
                            AppDialog.alert({
                                alertCtrl: this.alertCtrl,
                                message: 'Chưa tồn tại Zalo Support. Vui lòng chọn Hỗ Trợ!'
                            });
                        }
                    }*/
                });
            }
            return;
        });
    }

    supportOnline(flag: any) {
        console.log(flag);
    }

    recharge() {
        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.'
            });
        } else {
            this.app.getRootNav().push(RechargePage);
        }
    }

    withDrawal() {
        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.'
            });
        } else {
            this.app.getRootNav().push(WithDrawalPage);
        }
    }

    fundTransfer() {
        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.'
            });
        } else {
            this.app.getRootNav().push(FundTransferPage, {});
        }
    }

    goLottery(lotteryName, titleFull, id, titleGame) {
        let pageRedirect = null;
        let lotteryId = Number(id);
        if (lotteryId === 92) { // baucua1giay
            pageRedirect = BauCua1GiayPage;
        } else if (lotteryId === 93) { // baucua1phut
            pageRedirect = BauCua1PhutPage;
        } else if (lotteryId === 94) {
            pageRedirect = OanTuTiPage;
        } else if (lotteryId === 1000) {
            // pageRedirect = OanTuTiPage;
            this.theInAppBrowser.create('https://aseanlotto.com/', "_system", this.options);
            return
        } else if (lotteryId === 800 || lotteryId === 500 || lotteryId === 600 || lotteryId === 700) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: 'Comming Soon',
            });
            return;
        } else { // redirect to other page has footer tab bar button (lich su, nuoi so, chon so, dat cuoc)
            pageRedirect = LotteryTabsPage;
        }

        if (lotteryId == 300 || lotteryId == 304 || lotteryId == 305 || lotteryId == 402) {
            lotteryName = 'MB';
        }
        if (lotteryId == 301 || lotteryId == 302 || lotteryId == 303 || lotteryId == 400 || lotteryId == 401) {
            lotteryName = 'VN';
        }
        if (pageRedirect) {
            this.app.getRootNav().push(pageRedirect, {
                lotteryName: lotteryName,
                title: titleFull,
                lotteryId: id,
                titleGame: titleGame
            });
        } else {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Page không tồn tại!'
            });
        }
    }

    ngOnDestroy() { }


    // Sử dụng arrow function để giữ nguyên ngữ cảnh `this`
    private handleClickBound = (e: MouseEvent) => {
        const currentActiveIndex = this.loopSlider.getActiveIndex();
        const slideActive = this.loopSlider.container.querySelectorAll('ion-slide')[currentActiveIndex] as HTMLElement;
        const idSlideNoti = slideActive.querySelector('.idNotiSlide') as HTMLInputElement | null;

        if (idSlideNoti) {
            // console.log('idSlideNoti:', idSlideNoti.value);
            this.goSysMsg(idSlideNoti.value);
        } else {
            console.warn("idNotiSlide not found.");
        }
    };


    onSlideChanged(slider: Slides) {

        // let currentActive = this.loopSlider.getActiveIndex();
        // let slideActive = slider.container.querySelectorAll('ion-slide')[currentActive];

        // if (slideActive) {
        //     // Store the listener function in a variable
        //     const handleClick = (e: MouseEvent) => {
        //         const idSlideNoti = slideActive.querySelector('.idNotiSlide') as HTMLInputElement | null;

        //         // Check if idSlideNoti exists and has a value
        //         if (idSlideNoti) {
        //             console.log('====================================');
        //             console.log('idSlideNoti', idSlideNoti);
        //             console.log('====================================');
        //             this.goSysMsg(idSlideNoti.value);
        //         } else {
        //             // Handle the case where idSlideNoti does not exist
        //             console.warn("idNotiSlide not found.");
        //         }
        //     };

        //     // // Remove the previous click event listener if it exists
        //     // slideActive.removeEventListener("click", handleClick);

        //     // // Add the new click event listener
        //     slideActive.addEventListener('click', handleClick);
        // }


        let previousActiveSlide: HTMLElement | null = null;
        let currentActiveIndex = this.loopSlider.getActiveIndex();

        // Lấy phần tử slide hiện tại
        let slideActive = this.loopSlider.container.querySelectorAll('ion-slide')[currentActiveIndex] as HTMLElement;

        // Xóa sự kiện `click` khỏi slide trước đó nếu tồn tại
        if (previousActiveSlide) {
            previousActiveSlide.removeEventListener('click', this.handleClickBound);
        }

        // Gán sự kiện `click` cho slide hiện tại
        if (slideActive) {
            slideActive.addEventListener('click', this.handleClickBound);
            previousActiveSlide = slideActive; // Cập nhật lại `previousActiveSlide`
        }
    }

    autoPlaySliderNoti() {
        let slider_index = this.loopSlider.getActiveIndex();
        if (slider_index < this.msgList.length) {
            this.loopSlider.slideTo(slider_index + 1);
        } else {
            this.loopSlider.slideTo(0);
        }
    }
    autoPlaySliderBanner() {
        let sliderBannerIndex = this.loopSliderBanner.getActiveIndex();
        if (sliderBannerIndex < this.bannerList.length) {
            this.loopSliderBanner.slideTo(sliderBannerIndex + 1);
        } else {
            this.loopSliderBanner.slideTo(0);
        }
    }

    ionViewWillEnter() {
        this.wBox = 120;
        this.hBox = 115;
        this.apiGetBalance();
    }

 

    ionViewWillLeave() {
        this.apiGetBalance();
    }

    showAccountTest() {
        this.cs.flagVerifyNumber = 1;
        if (this.cs.flagVerifyNumber) {
            this.userService.accountTryTest(undefined, this).then(data => {

                if (data['msg'] === '') {
                    let modalAccountTest = this.modalCtrl.create(UserTest, {
                        userData: data
                    });
                    modalAccountTest.present();
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            });
        } else {
            let modalAccountTest = this.modalCtrl.create(UserTest, {
                userData: this.params.data
            });
            modalAccountTest.present();
        }
    }

    showPopupNoti() {
        let dataParams = {};
        this.userService.sysMsgBean(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                let arrMsg = data['msglist'];
                let getIDFirstPopup = '';
                for (let i = 0; i < arrMsg.length; i++) {
                    if (arrMsg[i].status === 2 && getIDFirstPopup === '') { // get popup latest
                        getIDFirstPopup = arrMsg[i].id;
                    } else if (arrMsg[i].status === 0) {
                        let objPromo = {
                            title: arrMsg[i].title,
                            id: arrMsg[i].id,
                            saveTime: arrMsg[i].savetime,
                            content: arrMsg[i].content,
                            url: arrMsg[i].photourl
                        };
                        this.arrObjPromo.push(objPromo);
                    }
                }
                if (getIDFirstPopup === '') return;
                let postData = { id: getIDFirstPopup };
                this.userService.sysMsgBeanInfo(postData, this.alertCtrl).then(data => {
                    if (!data["msg"]) {
                        let alertNoti = this.alertCtrl.create({
                            title: data["sysmsg"]["title"],
                            buttons: ['OK'],
                            message: data["sysmsg"]["content"],
                            cssClass: 'alertNoti'
                        });
                        alertNoti.present();
                    } else {
                        AppDialog.alert({
                            alertCtrl: this.alertCtrl,
                            message: data["msg"]
                        });
                    }
                });
            }
        });
    }

    feedback() {
        this.app.getRootNav().push(FeedbackPage);
    }
    speedtest() {
        this.nav.push(SpeedTestPage, {
            serverList: ""
        });
    };

    goToThirdPartyGame(keyLaunch: string) {

        if (!this.isAccountTest) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Tài khoản chơi thử, không thực hiện được thao tác này.',
            });
            return;
        }
        AppDialog.toast({
            toastCtrl: this.toastCtrl,
            message: 'Comming Soon',
        });

    }

    onSelectMTChange(event: any) {
        const selectedMT = event.target.value;

    }

    onSelectMNChange(event: any) {
        const selectedMT = event.target.value;

    }

    filterLotteries(lotteries: any[], subtype: string): any[] {
        if (subtype === 'mt') {
            return this.filterMT(lotteries);
        }
        if (subtype === 'mn') {
            return this.filterMN(lotteries);
        } else {
            return lotteries;
        }
    }

    filterMT(lotteries: any[]): any[] {
        if (this.selectedMT === '-1') {
            // Return all lotteries if selectedValue is '0'
            return lotteries;
        } else {
            // Filter based on openday if selectedValue is not '0'
            return lotteries.filter(lottery =>
                lottery.openday.includes(this.selectedMT)
            );
        }
    }

    filterMN(lotteries: any[]): any[] {
        if (this.selectedMN === '-1') {
            // Return all lotteries if selectedValue is '0'
            return lotteries;
        } else {
            // Filter based on openday if selectedValue is not '0'
            return lotteries.filter(lottery =>
                lottery.openday.includes(this.selectedMN)
            );
        }
    }

    showListPromo() {
        this.app.getRootNav().push(PromoMsgPage, {
            data: this.arrObjPromo
        });
    }
}

export class LotteryInfo {
    id: number;
    name: string;
    title: string;
    src: string;
    description: string;
}




// WEBPACK FOOTER //
// ./src/pages/home/home.ts